/* eslint-disable functional/no-conditional-statement */
import { useEffect, useRef } from "react";
import { useSettingsValueData } from "./useSettingsValueData";

export function useToastsScrollRef() {
  const ref = useRef<HTMLDivElement>(null);
  const settings = useSettingsValueData();

  const toastElement = document.querySelector(
    ".mkhc-toast-fixed"
  ) as HTMLDivElement;
  const onScroll = () => {
    const isHeaderFixed = settings.data.styleOptions?.headerFixed;

    if (!isHeaderFixed) {
      const elementBottom = ref.current?.getBoundingClientRect()?.bottom ?? 0;
      if (elementBottom < 0) {
        toastElement.style.setProperty("position", "fixed");
      } else {
        toastElement.style.setProperty("position", "absolute");
      }
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", onScroll);

    return () => document.removeEventListener("scroll", onScroll);
  });

  return ref;
}
